module.exports = __webpack_public_path__ + "img/5-2.65e8ae8a.svg";